import './App.css';
import 'antd/dist/reset.css';
import { useEffect } from 'react';
import { store } from 'services/store';
import { setInitialized } from 'services/store/reducers/authReducer';
import { auth } from 'services/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { MainRoutes } from './routes';
import { GlobalAiChat } from 'shared/components';

function AppInner(): JSX.Element {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      store.dispatch(setInitialized(Boolean(firebaseUser)));
    });
    return unsubscribe;
  }, []);

  return (
    <>
      <MainRoutes />
      <GlobalAiChat />
    </>
  );
}

function App(): JSX.Element {
  return (
    <Provider store={store}>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <AppInner />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
